<template>
    <div>
        <DialogoConfirmar ref="dialogConfirmar" :msgAceptar="aceptar" :msgCancelar="cancelar" :msg="mensaje" />
        <v-overlay :value="overlay">
            <v-container fluid class="d-flex align-center justify-center">
                <v-row class="d-flex align-center justify-center">
                    <v-col cols="12" class="text-center">
                        <v-card color="white" class="px-5 py-10 elevation-6">
                            <!-- <v-img src="@/assets/Logo-bt-06.png" width="480" class="animacion-logo"></v-img> -->
                            <v-progress-circular indeterminate size="84" width="10" color="primary"
                                class="animacion-process ma-5"></v-progress-circular>
                            <v-card-text>
                                <div class="font-weight-primary primary--text text-center"
                                    :class="($vuetify.breakpoint.xsOnly) ? 'text-h6' : 'text-h5'">
                                    Estamos procesando tu solicitud de afiliación.
                                    <br>Por favor, <div class="d-inline font-weight-bold">no cierres la ventana.</div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-overlay>
        <DialogoBienvenida ref="dialogoBienvenida" :titulo="titulo" :text="text" :items="items" :componentKey="key" />
        <v-stepper v-model="stp" flat>
            <v-stepper-header class="font-weight-regular text-subtitle-2 elevation-0">
                <v-stepper-step step="1">
                    Datos personales
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2">
                    Datos Hijos
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3">
                    Datos de cónyuge
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="4">
                    Datos de contacto
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="5">
                    Datos profesionales
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="6">
                    Régimen de discapacidad
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="7">
                    Opción de nivel
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="8" color="orange">
                    Verificar datos
                </v-stepper-step>
            </v-stepper-header>
            <v-progress-linear v-if="loading" color="primary" indeterminate></v-progress-linear>
            <v-stepper-items class="elevation-0">
                <v-stepper-content step="1" class="pa-5">
                    <!-- personales -->
                    <FormPreAfi @hayConyuge="hayDatosConyuge" @siguiente="next"></FormPreAfi>
                </v-stepper-content>
                <v-stepper-content step="2" class="mb-10 pa-0">
                    <!-- Hijos -->
                    <FormPreHijos @atras="volver" @siguiente="next"></FormPreHijos>
                </v-stepper-content>
                <v-stepper-content step="3" class="mb-10 pa-0">
                    <!-- conyuge/conviviente -->
                    <FormConyuge @atras="volver" @siguiente="next"></FormConyuge>
                </v-stepper-content>
                <v-stepper-content step="4" class="mb-10 pa-0">
                    <!-- contactos -->
                    <FormPreContacto @atras="volver" @siguiente="next"></FormPreContacto>
                </v-stepper-content>
                <v-stepper-content step="5" class="mb-10 pa-0">
                    <!-- profesionales -->
                    <FormPreProfesionales @atras="volver" @siguiente="next"></FormPreProfesionales>
                </v-stepper-content>
                <v-stepper-content step="6" class="mb-10 pa-0">
                    <!-- Discapacidad -->
                    <FormDiscapacidad @atras="volver" @siguiente="next"></FormDiscapacidad>
                </v-stepper-content>
                <v-stepper-content step="7" class="mb-10 pa-0">
                    <!-- opcion de nivel-->
                    <FormPreNivel @atras="volver" @siguiente="next"></FormPreNivel>
                </v-stepper-content>
                <!-- Vista para comprobar los datos almacenados -->
                <v-stepper-content step="8" class="ma-0 pa-0">
                    <FormularioVista v-if="stp == '8'" @atras="volver" @siguiente="finalizarAfiliacion"
                        :key="componentKey" />
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex'
//componentes
import ExpansionPanelGen from '@/components/panels/ExpansionPanelGen.vue'
import FormPreContacto from '@/components/forms/FormPreContacto.vue'
import FormPreAfi from '@/components/forms/FormPreAfi.vue'
import FormPreNivel from '@/components/forms/FormPreNivel.vue'
import FormPreHijos from '@/components/forms/FormPreHijos.vue'
import FormConyuge from '@/components/forms/FormConyuge.vue'
import FormDiscapacidad from '@/components/forms/FormDiscapacidad.vue'
import FormProfesionales from '@/components/forms/FormEditarDatosProf.vue'
import FormPreProfesionales from '@/components/forms/FormPreProfesionales.vue'
import FormularioVista from '@/components/forms/FormularioVista.vue'
import DialogoConfirmar from '@/components/dialogos/DialogoConfirmar.vue'
import DialogoBienvenida from '@/components/dialogos/DialogoBienvenida.vue'

export default {
    name: 'FormularioAfiliacion',
    components: {
        ExpansionPanelGen,
        FormPreContacto,
        FormConyuge,
        FormPreAfi,
        FormPreNivel,
        FormPreHijos,
        FormProfesionales,
        FormDiscapacidad,
        FormPreProfesionales,
        FormularioVista,
        DialogoConfirmar,
        DialogoBienvenida,
    },
    data() {
        return {
            loading: false,
            //    isValid: false,
            correct: false,

            //ultimo paso
            ult: 8,

            stp: 1,
            key: 1,
            tituloOverride: '',
            mostrarPasoConyuge: false,
            componentKey: 0,
            mensaje: 'Por favor, verificá si tu número de matrícula es correcto antes de continuar.',
            aceptar: 'Si, es correcto',
            cancelar: 'No, cancelar',

            overlay: false,
            text: '',
            items: [],
        }
    },

    methods: {
        /*         ...mapActions('stepper', ['nextStep', 'backStep', 'pasoValido']), */
        ...mapActions('preafiliacion', ['cargaNuevoAfiliado', 'setValPreAfi', 'borrarDatosAfiliacion']),

        handleValidation(data) {
            //si los elementos del array son true
            this.pasoValido(data.every((index) => index == true))
        },
        goToHome() {
            this.$router.push('/login').catch(() => { })
        },
        hayDatosConyuge(data) {
            this.mostrarPasoConyuge = data
        },
        finalizarAfiliacion() {
            window.scrollTo(0, -100)
            this.loading = true
            this.overlay = true
            this.cargaNuevoAfiliado().then((result) => {
                if (result) {
                    if (!this.resPreAfiliacion.success) {
                        this.tituloOverride = "No pudimos procesar tu solicitud"
                        this.text = this.resPreAfiliacion.msg
                        this.items = this.resPreAfiliacion.detalle
                    } else {
                        this.tituloOverride = ''
                        this.text = ''
                        this.items = []
                    }
                    this.key += 1
                    this.$refs.dialogoBienvenida.abrirDialogo().then((result) => {
                        if (result) {

                            this.borrarDatosAfiliacion()
                            this.$router.push('/login').catch(() => {
                                location.reload()
                            })
                        }
                        else {
                            this.stp = 1

                        }
                    })
                }
            }).catch((error) => {
                console.error('Error al cargar el nuevo afiliado:', error);
            }).finally(() => {
                this.loading = false
                this.overlay = false
                // this.router.push('/Login').catch(() => { })
            })
            //console.log('Formulario enviado')
        },
        volver() {
            if (this.stp == 4) {
                if (this.noCargaConyuge) {
                    if (this.noCargaHijos) this.stp = 1
                    else this.stp = 2
                }
                else this.stp = 3
            }
            else if (this.stp == 3 && this.noCargaHijos) {
                this.stp = 1
            }
            else if (this.stp == 7) {
                if (this.tramitaDiscapacidad) this.stp = 6
                else this.stp = 5
            }
            else this.stp = this.stp - 1
            window.scrollTo(0, 0)
        },
        next() {
            window.scrollTo(0, -50)
            if (this.stp == 1 && this.noCargaHijos) {
                if (this.noCargaConyuge) this.stp = 4
                else this.stp = 3
            }
            else if (this.stp == 2 && this.noCargaConyuge) {
                this.stp = 4
            }
            else if (this.stp == 5) {
                if (this.tramitaDiscapacidad) this.stp = 6
                else this.stp = 7
            }
            else
                this.stp = this.stp + 1
        },
        forceRerender() {
            this.componentKey += 1;
        },
    },
    computed: {
        ...mapGetters('preafiliacion', ['nuevoAfiliado', 'preafi', 'datosPersonales', 'datosContacto', 'datosFamiliares', 'datosProfesionales', 'datosNivel', 'fechaestadocivil', 'cantHijos', 'datosConyuge', 'datosDiscapacidad', 'resPreAfiliacion']),

        noCargaConyuge() {
            return (this.datosPersonales.estadocivil == 1) || (this.datosPersonales.estadocivil == 10) || (this.datosPersonales.estadocivil == 5) || (this.datosPersonales.estadocivil == 7)
        },
        noCargaHijos() {
            return (this.cantHijos == '' || this.cantHijos == 0)
        },
        tramitaDiscapacidad() {
            return this.datosPersonales.tramita_discapacidad == 'S'
        },
        titulo() {
            if (this.tituloOverride) return this.tituloOverride
            switch (this.datosPersonales.sexo) {
                case 'M':
                    return '!Bienvenido a la Caja de Psicólogos!'
                case 'F':
                    return '!Bienvenida a la Caja de Psicólogos!'
                case 'X':
                    return '!Bienvenidx a la Caja de Psicólogos!'
                default:
                    return '!Bienvenida/o/x a la Caja de Psicólogos!'
            }
        },
    },
    mounted() {
        window.scrollTo(0, 0);
        if (!this.preafi) {
            this.setValPreAfi(true)
        } else {
            this.$refs.dialogConfirmar.abrirDialogo().then((result) => {
                if (!result) {
                    this.$router.push('/Login')
                    location.reload()
                }
                else {

                }
            })

        }
    },

} 
</script>

<style>
.custom-stepper {
    margin: 0 !important;
    padding: 0 !important;
}

.form-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: white;
    padding: 10px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
}
</style>